import {
    Settings,
    DateTime,
    Interval,
    Duration,
} from 'luxon';
import LocalizationStorage from './common/services/localizationStorage';

let language = LocalizationStorage.getCurrentLanguage();
if (language === 'en') {
    language = 'en-gb';
}

Settings.defaultZoneName = 'Europe/Vilnius';
Settings.defaultLocale = language;

export {
    DateTime,
    Interval,
    Duration,
};
